import iconCalendar from '@/assets/img/icons/icon_datepicker_calendar@2x.png';
import { DatePicker, DatePickerProps } from '@y0c/react-datepicker';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import './InputDate.scss';
import InputText from './InputText';

const PickerContainer = styled.div`
  position: relative;
  img {
    width: 24px;
    height: 24px;
    position: absolute;
    z-index: 1;
    left: 12px;
    top: 16px;
  }
  input {
    padding-left: 48px !important;
  }
`;

const InputDate = forwardRef<HTMLInputElement, DatePickerProps>(
  ({ name, ...props }, ref) => (
    <PickerContainer {...props}>
      <img src={iconCalendar} alt="캘린더" />
      <DatePicker
        dateFormat="YYYY.MM.DD"
        locale="ko"
        {...props}
        // onClear를 제외해야 정상작동함. 원인은 까먹음...
        inputComponent={({ onClear, ...inputProps }) => (
          <InputText name={name} ref={ref} {...inputProps} />
        )}
      />
    </PickerContainer>
  ),
);

export default InputDate;
